// In src/pages/Login.js

import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { signIn, resetPassword } from '../services/auth'; // Import resetPassword

// Import Material-UI components for a professional look
import {
  Avatar, Button, TextField, Link, Grid, Box,
  Typography, Container, CircularProgress
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetMessage, setResetMessage] = useState(''); // New state for reset message
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResetMessage(''); // Clear any previous messages
    setLoading(true);

    try {
      const userCredential = await signIn(email, password);
      const user = userCredential.user;

      // Get the user's ID token to securely identify them to our function
      const idToken = await user.getIdToken();

      // Call our live cloud function with the URL you found
      await fetch('https://setcustomclaims-ltocsivqja-uc.a.run.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ idToken }),
      });

      // Force a refresh of the token on the client to get the new custom claims
      await user.getIdToken(true);

      // Navigate to the homepage on successful login and claim setting
      navigate('/');

    } catch (err) {
      setError(err.message); // Display Firebase error messages to the user
      setLoading(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setError('Please enter your email address to reset your password.');
      return;
    }
    console.log('Attempting password reset for email:', email); // ADDED console.log
    setLoading(true);
    setError('');
    setResetMessage('');
    try {
      await resetPassword(email);
      console.log('Password reset request sent successfully to Firebase.'); // ADDED console.log
      setResetMessage('Password reset email sent! Please check your inbox.');
    } catch (err) {
      console.error('Password reset failed:', err); // ADDED console.error
      setError(`Failed to send password reset email: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && (
            <Typography color="error" variant="body2" align="center">
              {error.includes('auth/invalid-credential')
                ? 'Invalid email or password.'
                : error}
            </Typography>
          )}
          {resetMessage && (
            <Typography color="success.main" variant="body2" align="center">
              {resetMessage}
            </Typography>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loading}
            sx={{ mt: 3, mb: 2 }}
          >
            {loading ? <CircularProgress size={24} /> : 'Sign In'}
          </Button>
          {/* MODIFIED: Changed Grid container to stack items vertically */}
          <Grid container direction="column" sx={{ mt: 2 }}> 
            {/* MODIFIED: Removed 'item' prop and 'xs' prop, using sx to set width */}
            <Grid sx={{ width: '100%' }}> 
              <Link href="#" variant="body2" onClick={handlePasswordReset} disabled={loading}>
                Forgot password?
              </Link>
            </Grid>
            {/* MODIFIED: Removed 'item' prop and 'xs' prop, using sx to set width */}
            <Grid sx={{ width: '100%' }}>
              <Link component={RouterLink} to="/register" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
}

export default Login;